import { Button, Form, message, Input, Col, Row } from 'antd';
import AppHeader from 'components/AppHeader';
import React, { useState, useEffect } from 'react';
import statisticApis from 'api/statisticApis';
import { ContentRow } from 'components/ThemeComponents';
import { StyledTable, OFFSET_HEADER } from 'components/ThemeComponents';
import { fullDateTimeFormat } from 'helpers/dateTimeHelper';

export default function AccountStatisticsPage() {

  const [statistics, setStatistics] = useState([]);

  async function fetchAccountsInfo(params={}) {
    try {
      const res = await statisticApis.accounts(params);
      setStatistics(res);
    } catch (error) {
      message.info(error.message);
    }
  }

  useEffect(() => {
    fetchAccountsInfo()
  }, []);

  
  
  return (
    <>
      <h1>Accounts Statistics</h1>
      <pre>{JSON.stringify(statistics, null, 2)}</pre>
    </>
  );
}
